import axios from '../axios'

/*
 * 用户会员模块
 */

export const selectByPage = (data) => {
    return axios({
        url: '/member/selectByPage',
        method: 'post',
        data
    })
}
export const batchDisable = (data) => {
    return axios({
        url: '/member/batchDisable',
        method: 'post',
        data
    })
}
export const batchEnabled = (data) => {
    return axios({
        url: '/member/batchEnabled',
        method: 'post',
        data
    })
}
export const batchLogoff = (data) => {
    return axios({
        url: '/member/batchLogoff',
        method: 'post',
        data
    })
}
export const logoffCancel = (data) => {
    return axios({
        url: '/member/logoffCancel',
        method: 'post',
        data
    })
}
export const selectIntegralByPage = (data) => {
    return axios({
        url: '/memberIntegral/selectByPage',
        method: 'post',
        data
    })
}


export const getMyFans = (data) => {
    return axios({
        url: '/memberFollows/getMyFans',
        method: 'post',
        data
    })
}

export const getMyFollows = (data) => {
    return axios({
        url: '/memberFollows/getMyFollows',
        method: 'post',
        data
    })
}


export const getSelectById = (params) => {
    return axios({
        url: '/member/selectById',
        method: 'get',
        params
    })
}

export const getDeleteById = (params) => {
    return axios({
        url: '/member/delete',
        method: 'get',
        params
    })
}

export const getVisitorMe = (data) => {
    return axios({
        url: '/memberVisitor/getVisitorMe',
        method: 'post',
        data
    })
}

//审核个人语音介绍（status：2-审核通过；3-审核驳回；）
export const batchApproveVoice = (data) => {
    return axios({
        url: '/member/batchApproveVoice',
        method: 'post',
        data
    })
}

//审核头像（status：1-审核通过；2-审核驳回；）
export const batchApprovePic = (data) => {
    return axios({
        url: '/member/batchApprovePic',
        method: 'post',
        data
    })
}

//审核个人签名（status：1-审核通过；2-审核驳回；）
export const batchApproveNote = (data) => {
    return axios({
        url: '/member/batchApproveNote',
        method: 'post',
        data
    })
}

//审核昵称（status：1-审核通过；2-审核驳回；）
export const batchApproveNickName = (data) => {
    return axios({
        url: '/member/batchApproveNickName',
        method: 'post',
        data
    })
}


// WEBPACK FOOTER //
// ./src/http/app/member.js